// ExperienceModal.jsx
import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Row,
  Col,
  Checkbox,
} from "antd";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { TextArea } = Input;

const ExperienceModal = ({
  form,
  visible,
  onCancel,
  onSave,
  initialValues,
  sectors,
  positions,
  onEdit,
  isSubmitting,
}) => {
  const [isEditMode, setIsEditMode] = useState(initialValues !== null);
  const [isOngoing, setIsOngoing] = useState(false);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const formattedValues = {
        description: values.description,
        jobPositionId: values.jobPositionId,
        companyName: values.companyName,
        companySectorId: values.companySectorId,
        startMonth: values.startDate.$M + 1,
        startYear: values.startDate.$y,
        endMonth: isOngoing ? null : values.endDate?.$M + 1,
        endYear: isOngoing ? null : values.endDate?.$y,
      };

      if (isEditMode) {
        await onEdit(formattedValues, initialValues.id);
      } else {
        await onSave(formattedValues);
      }
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  useEffect(() => {
    setIsEditMode(initialValues !== null);
    if (initialValues) {
      const isCurrentlyWorking =
        !initialValues.endMonth || !initialValues.endYear;
      setIsOngoing(isCurrentlyWorking);

      form.setFieldsValue({
        companyName: initialValues.companyName,
        description: initialValues.description,
        companySectorId: initialValues.companySector.id,
        jobPositionId: initialValues.jobPosition.id,
        startDate: dayjs(
          `${initialValues.startYear}-${initialValues.startMonth}`
        ),
        endDate: isCurrentlyWorking
          ? null
          : dayjs(`${initialValues.endYear}-${initialValues.endMonth}`),
        isOngoing: isCurrentlyWorking,
      });
    } else {
      form.resetFields();
      setIsOngoing(false);
    }
  }, [initialValues, form]);

  const handleCancel = () => {
    form.resetFields();
    setIsOngoing(false);
    onCancel();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={800}
      closeIcon={<CloseOutlined />}
      title="İş Deneyimi">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="jobPositionId"
              label="Pozisyon"
              rules={[{ required: true, message: "Lütfen pozisyon seçiniz" }]}>
              <Select options={positions} placeholder="Pozisyon Seçiniz..." />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="companyName"
              label="Firma Adı"
              rules={[
                { required: true, message: "Lütfen firma adını giriniz" },
              ]}>
              <Input placeholder="Firma Adı" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="startDate"
              label="Başlangıç Tarihi"
              rules={[
                {
                  required: true,
                  message: "Lütfen başlangıç tarihini seçiniz",
                },
              ]}>
              <DatePicker picker="month" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="endDate" label="Ayrılma Tarihi">
              <DatePicker
                picker="month"
                style={{ width: "100%" }}
                disabled={isOngoing}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="isOngoing" valuePropName="checked">
          <Checkbox
            onChange={(e) => {
              setIsOngoing(e.target.checked);
              if (e.target.checked) {
                form.setFieldValue("endDate", null);
              }
            }}>
            Çalışmaya Devam Ediyorum
          </Checkbox>
        </Form.Item>

        <Form.Item name="companySectorId" label="Sektör">
          <Select options={sectors} placeholder="Sektör Seçiniz..." />
        </Form.Item>

        <Form.Item name="description" label="İş Tanımı">
          <TextArea rows={4} placeholder="İş Tanımı" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            onClick={handleSave}
            icon={<SaveOutlined />}
            loading={isSubmitting}
            block>
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExperienceModal;
